import axios from "axios";
import { PORTAL_API } from "../env";
import { getToken, updateToken } from "../shared/keycloak";

const axiosInstance = axios.create({
  timeout: 30000,
  baseURL: PORTAL_API
});

axiosInstance.interceptors.request.use(async (config) => {
  await updateToken(5);
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else if (config.headers?.Authorization) {
    delete config.headers.Authorization;
  }
  return config;
});

export default axiosInstance;
